import { isString } from 'lodash';

/**
 * 权限指令
 * @param {*} app 
 * ZB-总部权限 SJG-权限
 */
export default function (app) {
  app.directive('role', {
    mounted(el, binding) {
      let value = binding.value;
      if (binding.value === undefined) {
        // console.error('v-role 指令需要传入权限值 -- 无需处理');
        return;
      }
      let role = JSON.parse(localStorage.getItem('userRole')) ?? [];
      let names = role.map(e => e.role);
      let show = false;
      if (isString(value)) {
        value = [value]
      }
      // console.log("--------------------------- v-role")
      // console.log(value, 'valuevaluevalue')
      // console.log(names)


      for (let i = 0; i < value.length; i++) {
        let item = value[i];
        if (names.includes(item)) {
          show = true;
          break;
        }
      }


      if (!show) {
        removeEl(el)
      }
    },
  })
}

const removeEl = (el) => el.parentNode && el.parentNode.removeChild(el)